(function () {
  const SECTION_SELECTOR = '.bogg-product-page';
  const FILTER_ORDER = ['Solids', 'Patterns', 'Quilted', 'Leopard', 'Sports'];

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  function initSection(section) {
    if (section.dataset.boggProductReady === 'true') {
      return;
    }

    section.dataset.boggProductReady = 'true';

    enhanceAddToCart(section);
    initSizeAndColorNavigation(section);
    initGallery(section);
  }

  function enhanceAddToCart(section) {
    const buyButtons = section.querySelector('[data-bogg-buy-buttons]');
    if (!buyButtons) {
      return;
    }

    const labelNode = buyButtons.querySelector('.add-to-cart-text__content > span > span');
    if (!labelNode) {
      return;
    }

    const rawText = labelNode.textContent.trim().toLowerCase();
    if (rawText.includes('sold out') || rawText.includes('unavailable')) {
      return;
    }

    const buttonLabel = buyButtons.dataset.addLabel || 'Add to Bag';
    const buttonPrice = buyButtons.dataset.buttonPrice || '';

    labelNode.textContent = buttonLabel;
    if (buttonPrice) {
      labelNode.dataset.boggPrice = `| ${buttonPrice}`;
    }
  }

  function initSizeAndColorNavigation(section) {
    const graph = window.BOGG_PRODUCT_GRAPH;
    if (!graph) {
      return;
    }

    const currentHandle = section.dataset.currentHandle;
    const familyKey = section.dataset.familyKey;
    const colorKey = section.dataset.colorKey;
    const swatchesRoot = section.querySelector('[data-bogg-swatches]');
    const tabsRoot = section.querySelector('[data-bogg-filter-tabs]');
    const sizeListRoot = section.querySelector('[data-bogg-size-list]');
    const familyItems = Array.isArray(graph.families?.[familyKey]) ? graph.families[familyKey] : [];

    renderSizeOptions(graph, colorKey, currentHandle, sizeListRoot);
    renderFilterTabs(familyItems, tabsRoot, swatchesRoot, currentHandle);
  }

  function renderSizeOptions(graph, colorKey, currentHandle, sizeListRoot) {
    if (!sizeListRoot) {
      return;
    }

    const sizeGroup = graph.sizeGroups?.[colorKey];
    const sizeOrder = Array.isArray(graph.sizeOrder) ? graph.sizeOrder : [];

    if (!sizeGroup || !sizeOrder.length) {
      return;
    }

    const items = sizeOrder
      .map((key) => sizeGroup[key])
      .filter(Boolean);

    if (!items.length) {
      return;
    }

    sizeListRoot.innerHTML = items
      .map((item) => {
        const isActive = item.handle === currentHandle;
        return `
          <a class="bogg-product-page__size-option${isActive ? ' is-active' : ''}" href="${item.url}">
            ${escapeHtml(item.label)}
          </a>
        `;
      })
      .join('');
  }

  function renderFilterTabs(familyItems, tabsRoot, swatchesRoot, currentHandle) {
    if (!tabsRoot || !swatchesRoot || !familyItems.length) {
      return;
    }

    const categorySet = new Set(
      familyItems
        .map((item) => item.category)
        .filter(Boolean)
    );

    const tabs = ['All', ...FILTER_ORDER.filter((category) => categorySet.has(category))];
    let activeFilter = 'All';

    tabsRoot.innerHTML = tabs
      .map(
        (tab) => `
          <button
            type="button"
            class="bogg-product-page__filter-tab${tab === activeFilter ? ' is-active' : ''}"
            data-filter-value="${escapeAttribute(tab)}"
          >
            ${escapeHtml(tab)}
          </button>
        `
      )
      .join('');

    const renderSwatches = () => {
      const filteredItems = activeFilter === 'All'
        ? familyItems
        : familyItems.filter((item) => item.category === activeFilter);

      const itemsToRender = filteredItems.length ? filteredItems : familyItems;

      swatchesRoot.innerHTML = itemsToRender
        .map((item) => {
          const isActive = item.handle === currentHandle;
          const imageHtml = item.image
            ? `<img class="bogg-product-page__swatch-image" src="${escapeAttribute(item.image)}" alt="${escapeAttribute(item.title)}" loading="lazy" width="240" height="240">`
            : '';

          return `
            <a
              class="bogg-product-page__swatch${isActive ? ' is-active' : ''}"
              href="${escapeAttribute(item.url)}"
              aria-label="${escapeAttribute(item.title)}"
            >
              <span class="bogg-product-page__swatch-media">${imageHtml}</span>
              <span class="visually-hidden">${escapeHtml(item.title)}</span>
            </a>
          `;
        })
        .join('');
    };

    tabsRoot.addEventListener('click', (event) => {
      const button = event.target.closest('[data-filter-value]');
      if (!button) {
        return;
      }

      activeFilter = button.dataset.filterValue || 'All';
      tabsRoot.querySelectorAll('[data-filter-value]').forEach((tabButton) => {
        tabButton.classList.toggle('is-active', tabButton === button);
      });
      renderSwatches();
    });

    renderSwatches();
  }

  function initGallery(section) {
    const gallery = section.querySelector('[data-bogg-gallery]');
    if (!gallery) {
      return;
    }

    const slides = Array.from(gallery.querySelectorAll('[data-bogg-gallery-slide]'));
    const track = gallery.querySelector('[data-bogg-gallery-track]');
    const counter = gallery.querySelector('[data-bogg-gallery-counter]');
    const dots = Array.from(gallery.querySelectorAll('[data-bogg-gallery-dot]'));
    const dialog = section.querySelector('[data-bogg-lightbox]');
    const stage = section.querySelector('[data-bogg-lightbox-stage]');
    const closeButton = section.querySelector('[data-bogg-lightbox-close]');
    const prevButton = section.querySelector('[data-bogg-lightbox-prev]');
    const nextButton = section.querySelector('[data-bogg-lightbox-next]');

    if (!slides.length || !track) {
      return;
    }

    let currentIndex = 0;
    let ticking = false;

    const updateGalleryState = () => {
      const closestIndex = slides.reduce((bestIndex, slide, index) => {
        const bestDistance = Math.abs(slides[bestIndex].offsetLeft - track.scrollLeft);
        const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
        return currentDistance < bestDistance ? index : bestIndex;
      }, 0);

      currentIndex = closestIndex;

      if (counter) {
        counter.textContent = `${currentIndex + 1} / ${slides.length}`;
      }

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
      });
    };

    const onScroll = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(() => {
        updateGalleryState();
        ticking = false;
      });
    };

    function renderLightbox(index) {
      if (!dialog || !stage) {
        return;
      }

      const safeIndex = ((index % slides.length) + slides.length) % slides.length;
      currentIndex = safeIndex;

      const template = slides[safeIndex].querySelector('template');
      stage.innerHTML = '';
      if (template) {
        stage.appendChild(template.content.cloneNode(true));
      }
      updateGalleryState();
    }

    function openLightbox(index) {
      if (!dialog) {
        return;
      }

      renderLightbox(index);
      if (typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      }
    }

    function closeLightbox() {
      if (dialog?.open) {
        dialog.close();
      }
    }

    track.addEventListener('scroll', onScroll, { passive: true });

    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        openLightbox(index);
      });
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const targetIndex = Number(dot.dataset.mediaIndex || 0);
        const targetSlide = slides[targetIndex];
        if (!targetSlide) {
          return;
        }

        track.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth'
        });
      });
    });

    closeButton?.addEventListener('click', closeLightbox);

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) {
        closeLightbox();
      }
    });

    prevButton?.addEventListener('click', () => {
      renderLightbox(currentIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      renderLightbox(currentIndex + 1);
    });

    updateGalleryState();
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
